import * as yup from 'yup';
// obtener las sucursales y los permisos de forma dinámica.
export const socialNetworksSchema = yup.object().shape({
  facebook: yup
    .string()
    .matches(
      /(?:https?:\/\/)?(?:www\.)?(mbasic.facebook|m\.facebook|facebook|fb)\.(com|me)\/(?:(?:\w\.)*#!\/)?(?:pages\/)?(?:[\w\-.]*\/)*([\w\-.]*)/,
      'Debe ser una URL de Facebook válida'
    ),
  instagram: yup
    .string()
    .matches(
      /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/,
      'Debe ser una URL de Instagram válida'
    ),
  twitter: yup
    .string()
    .matches(
      /(https:\/\/twitter.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/,
      'Debe ser una URL de Twitter válida'
    ),
  website: yup
    .string()
    .matches(
      /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
      'Debe ser una URL válida'
    ),
  youtube: yup
    .string()
    .matches(
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
      'Debe ser una URL de Youtube válida'
    )
});
